import { render, staticRenderFns } from "./merchant.vue?vue&type=template&id=4976b3d7&scoped=true&"
import script from "./merchant.vue?vue&type=script&lang=js&"
export * from "./merchant.vue?vue&type=script&lang=js&"
import style0 from "./merchant.vue?vue&type=style&index=0&id=4976b3d7&lang=less&scoped=true&"
import style1 from "./merchant.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4976b3d7",
  null
  
)

export default component.exports